import { store } from "../../../..";
import { globalActions } from "../../../../features/global/globalSlice";
import { userActions } from "../../../../features/user/userSlice";

const loader = async () => {
    const state = store.getState();
    const users = state.user.users;
    const sites = state.global.sites;
    const userLevels = state.global.userLevels;
    const promises = [];

    !users.length && promises.push(store.dispatch(userActions.getUsers()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !userLevels.length &&
        promises.push(store.dispatch(globalActions.getUserLevels()));

    await Promise.all(promises);

    return null;
};

export default loader;
